export const API_ENDPOINTS = {
  test: "http://81.71.153.47:8000/api",
  production: "https://api.xiangyaopai.cn/api",
} as const;

type ApiEnv = keyof typeof API_ENDPOINTS;

const configuredEnv = (import.meta.env.VITE_API_ENV || "production") as ApiEnv;

export const API_CONFIG = {
  env: configuredEnv in API_ENDPOINTS ? configuredEnv : "test",
  baseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    API_ENDPOINTS[configuredEnv in API_ENDPOINTS ? configuredEnv : "test"],
  localBaseUrl: import.meta.env.VITE_LOCAL_API_URL || "http://127.0.0.1:8069/api",
  localHealthUrl: import.meta.env.VITE_LOCAL_HEALTH_URL || "http://127.0.0.1:8069/health",
};
